import { ChronologyExportEvent } from '@/api/hooks/useChronologyExportEvents';
import { APIBaseChronos } from '@/api/hosts';
import { GenericExportProgressModal } from '@/components/molecules/GenericExportProgressModal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  caseId: string;
  chronologyId: string;
  chronologyTitle: string;
  onDownload: () => Promise<void>;
  isCreating: boolean;
  error?: string;
}

/**
 * Progress modal for chronology exports with source documents.
 * Thin wrapper around GenericExportProgressModal with chronology-specific configuration.
 */
export const ChronologyExportProgressModal = ({
  isOpen,
  onClose,
  caseId,
  chronologyId,
  chronologyTitle,
  onDownload,
  isCreating,
  error,
}: Props) => {
  return (
    <GenericExportProgressModal<ChronologyExportEvent>
      isOpen={isOpen}
      onClose={onClose}
      exportConfig={{
        progressEndpoint: `${APIBaseChronos}/api/case/${caseId}/chronology/${chronologyId}/export-progress`,
      }}
      itemName={`Chronology "${chronologyTitle}"`}
      onDownload={onDownload}
      isCreating={isCreating}
      error={error}
    />
  );
};
